module.exports = __webpack_public_path__ + "img/coaching-poster.48e042db.jpg";